import React from "react";
import { useNavigate } from "react-router";
import { ArrowLeft, Sparkles, UserPlus } from "lucide-react";

import { Button } from "../../components/ui/button";

interface Props {
  handleAdd: () => void;
}

export default function AdminTopBar({ handleAdd }: Props) {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-20 border-b border-white/5 bg-slate-950/95 px-4 py-3 text-white backdrop-blur">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3">
        <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
          <Button
            variant="ghost"
            size="icon"
            className="shrink-0 text-white hover:bg-white/10"
            onClick={() => navigate("/")}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div className="min-w-0">
            <p className="text-xs uppercase tracking-[0.4em] text-white/60">
              Dashboard
            </p>
            <h1 className="truncate text-base font-semibold sm:text-lg">
              Painel Transfer On Floripa
            </h1>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            className="border border-white/10 bg-white/5 text-white hover:bg-white/10"
            onClick={() => navigate("/admin-management/ia-add")}
          >
            <Sparkles className="h-4 w-4 sm:mr-2" />
            <span className="hidden sm:inline">IA</span>
          </Button>
          <Button
            size="sm"
            className="bg-primary text-primary-foreground hover:bg-primary/90"
            onClick={handleAdd}
          >
            <UserPlus className="h-4 w-4 sm:mr-2" />
            <span className="hidden sm:inline">Nova reserva</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
